import types from "./types";

const setUser = user => ({
  type: types.SET_USER,
  payload: user,
});

export default {
  setUser,
};



// WEBPACK FOOTER //
// ./src/state/auth/actions.js